import Glide from '@glidejs/glide';

export default function slidersInit(sliders = []) {
    const width = window.matchMedia('(max-width: 780px)');

    sliders.forEach((slider) => {
        const slideCount = slider.querySelectorAll('.glide__slide');
        let options;

        if (slider.classList.contains('testimonial_slider')) {
            options = {
                type: 'carousel',
                startAt: 1,
                focusAt: 'center',
                gap: 15,
                perView: 3,
                rewind: false,
                breakpoints: {
                    1024: {
                        perView: 2,
                        focusAt: 1,
                    },
                    780: {
                        perView: 1,
                    },
                },
            };
        } else if (slider.classList.contains('logo_slider')) {
            options = {
                type: 'carousel',
                startAt: 0,
                focusAt: 'center',
                gap: 75,
                perView: 8,
                autoplay: 1,
                animationDuration: 4000,
                animationTimingFunc: 'linear',
                breakpoints: {
                    780: {
                        perView: 4,
                    },
                },
            };
        }

        if (options) {
            const element = new Glide(slider, options);
            element.mount();
            if (!width.matches && slideCount.length <= 3 && slider.classList.contains('testimonial_slider')) {
                slider.classList.add('glide--disabled');
            }
        }
    });
}
